import { types } from "../types/types";

const initialState =[]



export const productReducer = ( state = initialState, action ) =>{

   
    switch ( action.type ) {

        case types.productAddNew:
            return [
                ...state,
                {...action.payload}
            ]
        case types.productUpdate:
            return [...state].map(
                    product => (product.id === action.payload.id) ? action.payload : product
                )
            
           
        case types.productDelete:
           
            return [...state].filter(
                product => (product.id !== action.payload.id)
            )

        case types.productLoaded:
            return [...action.payload]
            

           

        default:
           return state ;
    }

};